/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Input, InputNumber } from "antd";
import TextArea from "antd/es/input/TextArea";

export function FormInput({
  id,
  name = "",
  label = "",
  placeholder = "",
  required = false,
  rules = undefined,
  widthSize = "medium",
  textArea = 0,
  inputType = "text",
  value = '',
  onChange = () => { },
  ...rest
}: any) {
  // const spanSize =
  //   widthSize.toLowerCase() == "large"
  //     ? 24
  //     : widthSize.toLowerCase() == "small"
  //       ? 4
  //       : 8;
  return (
    <Col >
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        layout="vertical"
      // wrapperCol={{ span: 24 }}
      >
        {textArea ? (
          <TextArea
            showCount
            maxLength={textArea}
            placeholder={placeholder}
            autoComplete="off"
            onChange={onChange}
            {...rest}
          />
        ) : inputType.toLowerCase() == "number" ? (
          <InputNumber
            placeholder={placeholder}
            autoComplete="off"
            onChange={onChange}
            {...rest}
          />
        ) : inputType.toLowerCase() == "password" ?
          (
            <Input.Password
              placeholder={placeholder}
              autoComplete="off"
              onChange={onChange}
              value={value}
              {...rest}
            />
          ) : (
            <Input
              placeholder={placeholder}
              autoComplete="off"
              onChange={onChange}
              value={value}
              {...rest}
            />
          )}
      </Form.Item>
    </Col>
  );
}
